module.exports = __webpack_public_path__ + "media/images/application/icons/socials/icon-linkedin-04e5e46878b0121cca90b5211417b933.svg";